"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var fr = {
  'contractSelectorMessages.contractDetails': 'Détails du contrat',
  'contractSelectorMessages.discount': 'Remise',
  'contractSelectorMessages.items': 'Articles',
  'contractSelectorMessages.lastModified': 'Dernière modification',
  'contractSelectorMessages.lastModifiedBy': 'Dernière modification effectuée par',
  'contractSelectorMessages.markup': 'Majoration',
  'contractSelectorMessages.revision': 'Révision',
  'createOptionStep.contractNamePlaceholder': "Ex.\u202F: Condition de prix catalogue avec {name}",
  'createOptionStep.header': 'Vous disposez déjà de contrats de prix catalogue avec {name}. Ajoutez des produits à un contrat existant ou créez-en un nouveau.',
  'createOptionStep.newOptionButtonDescription': 'Créer un nouveau contrat avec {name}',
  'createOptionStep.newOptionButtonTitle': 'Créer un nouveau contrat',
  'createOptionStep.updateExistingOptionButtonDescription': 'Ajouter des références SKU au contrat existant avec {name}',
  'createOptionStep.updateExistingOptionButtonTitle': 'Mettre à jour un contrat existant',
  'generalModal.backButtonText': 'Retour',
  'generalModal.closeButtonText': 'Fermer',
  'generalModal.defaultErrorCreationMessage': 'Erreur lors de la création du contrat de prix catalogue',
  'generalModal.financialFlowsSupport': 'Assistance Flux financiers',
  'generalModal.forAssistanceText': "pour obtenir de l'aide",
  'generalModal.nextButtonText': 'Suivant',
  'generalModal.pleaseContactText': 'Veuillez contacter',
  'generalModal.termButtonCreatedStatus': 'Créé',
  'generalModal.termButtonCreatingStatus': 'Création',
  'generalModal.termButtonDefaultText': 'Envoyer pour approbation',
  'generalModal.title': 'Créer un contrat de prix catalogue',
  'generalModal.viewPendingContractText': 'Cliquez ici pour afficher le contrat en attente dans le Gestionnaire des contrats.',
  'listPriceConfirmStep.allSkusHaveContractsErrorMessage': 'Toutes les références SKU sont associées à un contrat de prix catalogue, établi entre {merchantName} et {fulfillerName}.',
  'listPriceConfirmStep.buyer': 'Acheteur',
  'listPriceConfirmStep.confirmContractDetails': 'Confirmer les détails du contrat',
  'listPriceConfirmStep.discount': 'Remise',
  'listPriceConfirmStep.endDate': 'Date de fin',
  'listPriceConfirmStep.errorLoadingSkusMessage': 'Erreur lors du chargement des références SKU',
  'listPriceConfirmStep.excludedSkus': 'Exclus ({count})',
  'listPriceConfirmStep.includedSkus': 'Références SKU ({count})',
  'listPriceConfirmStep.markup': 'Majoration',
  'listPriceConfirmStep.name': 'Nom',
  'listPriceConfirmStep.noEndDate': 'Pas de date de fin',
  'listPriceConfirmStep.seller': 'Vendeur',
  'listPriceConfirmStep.skusHaveContractsWarning': 'Un contrat de prix catalogue établi entre {fulfillerName} et {merchantName} existe déjà pour ces références SKU.',
  'listPriceConfirmStep.startDate': 'Date de début',
  'listPriceCreateStep.existingHeader': "Sélectionnez l'un des contrats catalogue passés avec {name}.",
  'listPriceCreateStep.newHeader': 'Nommez votre contrat.',
  'listPriceInitiatorButton.listPriceInitiatorButtonText': 'Créer un contrat',
  'listPriceInitiatorButton.noIdentityMessage': "Votre ID de marchand n'est pas autorisé à effectuer cette action.",
  'listPriceInitiatorButton.noSkusSelectedMessage': 'Avant de créer un contrat, vous devez sélectionner des références SKU valides.',
  'listPriceInitiatorButton.tooltipMessage': "{message}. Pour obtenir de l'aide, contactez {email}.",
  'selectMerchantStep.header': 'Sélectionnez le marchand qui achètent les produits.',
  'selectMerchantStep.merchantSelectLabel': 'Marchand',
  'skuSelector.apiErrorTemplate': "Erreur lors de {serviceComment}. (Code de r\xE9ponse\u202F: {status})",
  'skuSelector.apiSceneServiceComment': "récupération de l'URI de la scène",
  'skuSelector.apiSkuServiceComment': 'recherche de références SKU',
  'skuSelector.csvDownloadLink': 'Total de {number} références SKU (cliquez ici pour télécharger le CSV)',
  'skuSelector.csvDownloadName': 'all_skus.csv',
  'skuSelector.currentlyViewingText': 'Affichage en cours',
  'skuSelector.descriptionFilterLabel': 'Description',
  'skuSelector.emptyBinPlaceholder': 'Recherchez des produits par nom ou référence SKU, puis ajoutez-les ici.',
  'skuSelector.filterOptionsTitle': 'Options de filtrage',
  'skuSelector.nameFilterLabel': 'Nom',
  'skuSelector.removeSkuButtonText': 'Retirer des références SKU',
  'skuSelector.searchFilterLabel': 'Filtrer par mot-clé...',
  'skuSelector.skuBinNoFilterResult': "Aucun résultat pour '{filter}'.",
  'skuSelector.skuCardDisabledTooltip': "Le sélecteur est actuellement désactivé. Impossible d'ajouter ce produit ou de le retirer de votre liste.",
  'skuSelector.skuCountText': 'sur {totalCount} références SKU',
  'skuSelector.skuFilterLabel': 'Référence SKU',
  'skuSelector.skuSearchAddSkuButtonText': 'Ajouter des références SKU',
  'skuSelector.skuSearchAddSkuPrompt': "Vous voulez ajouter plusieurs r\xE9f\xE9rences SKU simultan\xE9ment\u202F?",
  'skuSelector.skuSearchBarHelpText': 'Commencez la saisie ci-dessus pour rechercher des produits.',
  'skuSelector.skuSearchBarLabel': 'Entrez un nom de produit ou sa référence SKU.',
  'skuSelector.skuSearchDefaultErrorMessage': 'Un problème est survenu.',
  'skuSelector.skuSearchDetailedErrorMessage': '{error}. Veuillez réessayer.',
  'skuSelector.skuSearchNextButtonText': 'Suivant',
  'skuSelector.skuSearchNotFoundErrorMessage': "Produits introuvables pour '{query}'",
  'skuSelector.skuSearchPrevButtonText': 'Précédent',
  'skuSelector.uploadModalAddButtonText': 'Ajouter ({totalCount})',
  'skuSelector.uploadModalAddError': "Les références SKU ci-dessus n'ont pas pu être ajoutées, car elles n'existent pas dans la plateforme.  Il est possible qu'elles contiennent des fautes de frappe, par exemple des caractères non-alphanumériques ou des majuscules erronées. Veuillez les réviser et réessayer.",
  'skuSelector.uploadModalAddTitle': 'Ajouter des références SKU',
  'skuSelector.uploadModalCloseButtonText': 'Fermer',
  'skuSelector.uploadModalHelpText': "Entrez la liste des références SKU séparées par un espace. Le traitement simultané de milliers de références SKU peut prendre un certain temps. Si l'opération est trop longue, réduisez-la en plusieurs chargements plus petits.",
  'skuSelector.uploadModalRemoveButtonText': 'Retirer ({totalCount})',
  'skuSelector.uploadModalRemoveError': "Les références SKU ci-dessus n'ont pas pu être retirées, car elles sont désignées comme ne pouvant pas être supprimées.",
  'skuSelector.uploadModalRemoveTitle': 'Retirer des références SKU',
  'skuSelector.uploadModalSkuLabel': 'Références SKU',
  'skuSelector2.apiErrorTemplate': "Erreur lors de {serviceComment}. (Code de r\xE9ponse\u202F: {status})",
  'skuSelector2.apiSceneServiceComment': "récupération de l'URI de la scène",
  'skuSelector2.apiSkuServiceComment': "Recherche d'ID de produit",
  'skuSelector2.csvDownloadLink': '{number} Total Product Ids (Cliquez ici pour télécharger CSV)',
  'skuSelector2.csvDownloadName': 'all_skus.csv',
  'skuSelector2.currentlyViewingText': 'Affichage en cours',
  'skuSelector2.descriptionFilterLabel': 'Description',
  'skuSelector2.emptyBinPlaceholder': 'Recherchez des produits par leur nom ou leur ID produit et ajoutez-les ici.',
  'skuSelector2.filterOptionsTitle': 'Options de filtrage',
  'skuSelector2.nameFilterLabel': 'Nom',
  'skuSelector2.removeSkuButtonText': "'Supprimer les ID de produit",
  'skuSelector2.searchFilterLabel': 'Filtrer par mot-clé...',
  'skuSelector2.skuBinNoFilterResult': "Aucun résultat pour '{filter}'.",
  'skuSelector2.skuCardDisabledTooltip': "Le sélecteur est actuellement désactivé. Impossible d'ajouter ce produit ou de le retirer de votre liste.",
  'skuSelector2.skuCountText': 'sur {totalCount} ID de produit',
  'skuSelector2.skuFilterLabel': 'Identifiant du produit',
  'skuSelector2.skuSearchAddSkuButtonText': 'Ajouter des identifiants de produit',
  'skuSelector2.skuSearchAddSkuPrompt': 'Vous souhaitez ajouter plusieurs ID de produit à la fois?',
  'skuSelector2.skuSearchBarHelpText': 'Commencez la saisie ci-dessus pour rechercher des produits.',
  'skuSelector2.skuSearchBarLabel': 'Saisissez un nom de produit ou un ID de produit.',
  'skuSelector2.skuSearchDefaultErrorMessage': 'Un problème est survenu.',
  'skuSelector2.skuSearchDetailedErrorMessage': '{error}. Veuillez réessayer.',
  'skuSelector2.skuSearchNextButtonText': 'Suivant',
  'skuSelector2.skuSearchNotFoundErrorMessage': "Produits introuvables pour '{query}'",
  'skuSelector2.skuSearchPrevButtonText': 'Précédent',
  'skuSelector2.uploadModalAddButtonText': 'Ajouter ({totalCount})',
  'skuSelector2.uploadModalAddError': "Les ID de produit ci-dessus n'ont pas pu être ajoutés car ils n'existent pas sur la plate-forme. Ils peuvent contenir des fautes de frappe, telles que des caractères non alphanumériques ou une mise en majuscule incorrecte. Veuillez les consulter et réessayer.",
  'skuSelector2.uploadModalAddTitle': 'Ajouter des identifiants de produit',
  'skuSelector2.uploadModalCloseButtonText': 'Fermer',
  'skuSelector2.uploadModalHelpText': "Entrez une liste d'ID de produit séparés par des espaces. Le traitement simultané de milliers d'ID de produit peut prendre un certain temps. Si vous rencontrez des retards importants, essayez d'effectuer plusieurs téléchargements plus petits.",
  'skuSelector2.uploadModalRemoveButtonText': 'Retirer ({totalCount})',
  'skuSelector2.uploadModalRemoveError': "Les ID de produit ci-dessus n'ont pas pu être supprimés car ils sont marqués comme inamovibles.",
  'skuSelector2.uploadModalRemoveTitle': 'Supprimer les ID de produit',
  'skuSelector2.uploadModalSkuLabel': 'ID de produit'
};
var _default = fr;
exports.default = _default;